import ComingSoon from '../components/ComingSoon'

export default function Messages() {
  return <ComingSoon title="Messages" subtitle="In-app inbox" />
}
